import React, { useState, useRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ReactComponent as CalendarIcon } from '../components/icon/calendaricon.svg';
import Nav from '../components/Nav';

const Header = ({ onDateChange }) => {
  const [startDate, setStartDate] = useState(() => {
    const now = new Date();
    if (now.getHours() < 7) {
      now.setDate(now.getDate() - 1);
    }
    now.setHours(7, 0, 0, 0); 
    return now;
  });

  const [calendarOpen, setCalendarOpen] = useState(false);
  const calendarRef = useRef(null);
  const isInitialMount = useRef(true); // 첫 로딩 여부 확인용 ref

  const handleDateChange = date => {
    const displayDate = new Date(date);
    displayDate.setHours(7, 0, 0, 0); 
    setStartDate(displayDate);
    setCalendarOpen(false);
  };

  const handleClickOutside = event => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setCalendarOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      onDateChange(startDate);
      // console.log("새로고침 시 API 요청에 사용할 날짜:", startDate.toLocaleString());
      isInitialMount.current = false; // 첫 로딩 이후 false로 변경
    }
  }, [startDate, onDateChange]);

  const handleSearchClick = () => {
    const apiDate = new Date(startDate);
    apiDate.setHours(7, 0, 0, 0); 

    // console.log("API 요청에 사용할 날짜:", apiDate.toLocaleString());
    onDateChange(apiDate);
  };

  return (
    <header className='h-[6%] fixed top-0 left-0 w-full change_h flex flex-col justify-center bg-white p-3 z-50'>
      <div className='w-full ml-[25px] flex flex-row items-center change_text'>
        <div className='mr-[1%]'>조회일자</div>
        <div className='relative w-[120px] sm:w-[180px] md:w-[240px] change_2h bg-yellow-300 flex items-center border-2 border-black'>
          <button
            className='w-full h-full flex items-center justify-between px-[4%] change_text bg-blue-300'
            onClick={() => setCalendarOpen(!calendarOpen)}
          >
            <span className='flex-1 text-center'>
              {startDate ? startDate.toLocaleDateString() : ''}
            </span>
            <CalendarIcon className='w-5 h-5 md:w-6 md:h-6 lg:w-7 lg:h-7 xl:w-8 xl:h-8' />
          </button>
          {calendarOpen && (
            <div ref={calendarRef} className='absolute top-full left-1/2 transform -translate-x-1/2 mt-2'>
              <DatePicker
                selected={startDate}
                onChange={handleDateChange}
                inline
                dateFormat="yyyy/MM/dd"
              />
            </div>
          )}
        </div>
        <button
          onClick={handleSearchClick}
          className='ml-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600'
        >
          조회
        </button>
      </div>
    </header>
  );
};

export default Header;
